import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";
import { SettingsTabs } from "@/routes/settings/SettingsTabs";
import { SettingsMeta } from "./SettingsMeta";
import {
  getCurrentSettingsTab,
  getSettingsTabs,
  SETTINGS_TAB_PATHS,
} from "./settingsTabsShared";

export function SettingsMetaRoute() {
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setBreadcrumbs([
      { label: "Settings", path: "/settings" },
      { label: "Integrations", path: "/settings/integrations" },
      { label: "Meta", path: "/settings/integrations/meta" },
    ]);

    return () => {
      clearBreadcrumbs();
    };
  }, []);

  const handleTabChange = (value: string) => {
    const path = SETTINGS_TAB_PATHS[value];
    if (path) navigate(path);
  };

  return (
    <SettingsTabs
      value={getCurrentSettingsTab(location.pathname)}
      tabs={getSettingsTabs({ integrationsContent: <SettingsMeta /> })}
      onValueChange={handleTabChange}
    />
  );
}
